/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Swedish (sv) · Journal / blog page
   English is the source of truth in blog.html; this file supplies the
   Swedish counterpart for each blog.* data-i18n key. Missing keys fall
   back to English automatically (see i18n.js).

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) stay in English.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.sv = window.TD_I18N.sv || {};
  Object.assign(window.TD_I18N.sv, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'Om Dr. Ronlán',

    /* ── Page head ── */
    'blog.eyebrow': 'Journal',
    'blog.title': 'Anteckningar från<br><em>laboratoriet.</em>',
    'blog.intro': 'Vetenskapen, serumen och hudvårdsritualerna hos Transderma: trettio års forskning, översatt för badrumshyllan.',

    /* ── Filter bar ── */
    'blog.filter.all': 'Alla',
    'blog.filter.science': 'Vetenskap',
    'blog.filter.ingredients': 'Ingredienser',
    'blog.filter.routines': 'Rutiner',
    'blog.filter.longevity': 'Livslängd',

    /* ── Shared "Read" link ── */
    'blog.read': 'Läs <span class="arr">→</span>',

    /* ── Coming-soon labels (theme template; articles not yet live) ── */
    'blog.soon': 'Kommer snart',
    'blog.notice.upcoming': 'Artiklar publiceras snart · anmäl dig nedan för avisering',

    /* ── Article 1 (featured) ── */
    'blog.a1.cat': 'Vetenskap',
    'blog.a1.time': '7 min läsning',
    'blog.a1.date': 'Apr 2026',
    'blog.a1.title': 'Varför <em>vattenfri</em> hudvård faktiskt fungerar, och varför de flesta serum inte gör det.',
    'blog.a1.excerpt': 'Sextio till nittio procent av innehållet i en genomsnittlig serumflaska är vatten. Resten är emulgeringsmedel, förtjockningsmedel och konserveringsmedel. När vi säger att Transderma är vattenfritt menar vi att varje droppe är aktiv formula. Här är kemin bakom det valet, och varför det förändrar hur mycket som faktiskt når huden.',
    'blog.a1.read': 'Läs artikeln <span class="arr">→</span>',

    /* ── Article 2 ── */
    'blog.a2.cat': 'Ingredienser',
    'blog.a2.time': '5 min',
    'blog.a2.title': 'Retinylpalmitat kontra retinol: en mildare väg till förnyelse.',
    'blog.a2.excerpt': 'Varför Serum A använder palmitatestern av A-vitamin: hur den omvandlas inuti huden, varför den stabiliseras med E-vitamin, och vem den passar bäst för.',

    /* ── Article 3 ── */
    'blog.a3.cat': 'Vetenskap',
    'blog.a3.time': '6 min',
    'blog.a3.title': 'Transdermal tillförsel, förklarad för badrumshyllan.',
    'blog.a3.excerpt': 'Vad "förbi stratum corneum" faktiskt betyder, hur squalan bär aktiva vitaminer genom hudens yttre lager, och djupforskningen bakom namnet.',

    /* ── Article 4 ── */
    'blog.a4.cat': 'Rutiner',
    'blog.a4.time': '4 min',
    'blog.a4.title': 'Bygg en Transderma-rutin i fem steg.',
    'blog.a4.excerpt': 'Morgon, kväll, appliceringsordning, och hur du lägger Serum M utan att späda ut det aktiva under. Rytmen som gör fem flaskor till ett system.',

    /* ── Article 5 ── */
    'blog.a5.cat': 'Livslängd',
    'blog.a5.time': '8 min',
    'blog.a5.title': 'Mitokondriefrågan: varför Serum O är livslängdsserumet.',
    'blog.a5.excerpt': 'PQQ, kreatin, B-vitaminer. Argumentet för att behandla hudens åldrande på den cellulära energinivån, och varför mitokondriellt stöd står i centrum för den mest särpräglade formulan i serien.',

    /* ── Article 6 ── */
    'blog.a6.cat': 'Ingredienser',
    'blog.a6.time': '5 min',
    'blog.a6.title': 'Resveratrol, piceid och vetenskapen bakom märken efter akne.',
    'blog.a6.excerpt': 'Hur fyra ingredienser (och inget vatten) tar itu med ojämn ton, miljöskador och de märken som dröjer kvar långt efter att finnen är borta.',

    /* ── Article 7 ── */
    'blog.a7.cat': 'Vetenskap',
    'blog.a7.time': '6 min',
    'blog.a7.title': 'Ceramider, kolesterol och hudens lipidbruk.',
    'blog.a7.excerpt': 'Varför en barriär som behåller sin egen fukt är målet, och hur Serum M kompletterar de lipider huden redan vet hur den ska tillverka.',

    /* ── Article 8 ── */
    'blog.a8.cat': 'Rutiner',
    'blog.a8.time': '3 min',
    'blog.a8.title': 'Två droppar räcker. Argumentet mot överanvändning.',
    'blog.a8.excerpt': 'Ett koncentrerat vattenfritt serum beter sig inte som en fuktkräm med 65 % vatten. Varför mindre material når längre när formulan arbetar med din hud, inte mot den.',

    /* ── Newsletter ── */
    'blog.news.eyebrow': 'The Journal · Månadsvis',
    'blog.news.title': 'Ett kort brev <em>varje månad.</em>',
    'blog.news.body': 'Nya artiklar, lågmälda produktnyheter och då och då ett ord från labbet. Inga kampanjer, inget fluff. En genomtänkt notis och en avregistreringslänk i varje mejl.',
    'blog.news.placeholder': 'din@email.com',
    'blog.news.aria': 'E-postadress',
    'blog.news.button': 'Prenumerera'

  });
})();
